// API Variables
const API_KEY_ONLY            = '7af11c237343537994a3841aef8f4eef';
export const API_KEY          = `?api_key=${API_KEY_ONLY}&language=en-US&page=1`;
export const URL_POPULAR      = 'https://api.themoviedb.org/3/movie/popular';
export const URL_TOP_RATED    = 'https://api.themoviedb.org/3/movie/top_rated';
export const URL_UPCOMING     = 'https://api.themoviedb.org/3/movie/upcoming';
export const URL_NOW_PLAYING  = 'https://api.themoviedb.org/3/movie/now_playing';
export const URL_MOVIE        = 'https://api.themoviedb.org/3/movie/';

// General App Settings
// export const APP_FOLDER_NAME  = '/movie-app';

// LocalStorage Defaults
export const STORAGE_YOUR_MOVIES = 'movie-app-your-favourites';